module.exports = __webpack_public_path__ + "img/no.c8ce5b53.png";